import React from 'react';
function Home() {

    window.location.href = 'https://coventia.es';

    return (
        <p></p>
    );
}

export default Home;